/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Input from "../common/Input";
import {STATUS} from "../common/Const";
import {calculateDisplayedErrors} from "../common/Helpers";
import { useTranslation } from 'react-i18next';

const StudentForm = ({firstName, lastName, email, mobile, additionalInfo, touched, errors, onBlur, onChange, onSubmit, onCancel, status, client, clientUrl}) => {
  const { t: tr } = useTranslation();
  const err = calculateDisplayedErrors(errors, touched, status);
  const disabled = status === STATUS.SUBMITTING;
  const clientName = `${client.firstName || ''} ${client.lastName || ''}`.trim();
  return (
    <div>
      <h2 className="manage-title">{tr("manage:student_14")}</h2>
      <form id="student-form" onSubmit={onSubmit}>
        <div className="form-group">
          <strong className="mr-2">{tr("manage:client_108")}:</strong>
          {clientUrl && !disabled ? (
            <Link to={clientUrl} className="student-client-link">{clientName || tr("manage:client_108")}</Link>
          ) : <span>{clientName || "—"}</span>}
        </div>
        <div className="form-row">
          <div className="col-md-2 mb-1  ">
            <Input label={tr("common:firstName")} onBlur={onBlur} onChange={onChange} name="firstName" value={firstName} error={err.firstName} placeholder={tr("common:firstName")} />
          </div>
          <div className="col-md-2 mb-1  ">
            <Input label={tr("common:lastName")} onBlur={onBlur} onChange={onChange} name="lastName" value={lastName} error={err.lastName} placeholder={tr("common:lastName")} />
          </div>
          <div className="col-md-8 mb-1  ">
            <Input label={tr("manage:additionalInformation_353")} onBlur={onBlur} onChange={onChange} name="additionalInfo" value={additionalInfo} error={err.additionalInfo} placeholder={tr("manage:additionalInformation_353")} />
          </div>
        </div>

        <div className="form-row">
          <div className="col-md-6 mb-1">
            <Input label={tr("manage:emailOptional_109")} name="email" value={email || ''} onBlur={onBlur} onChange={onChange} error={err.email} />
          </div>
          <div className="col-md-6 mb-1">
            <Input label={tr("manage:phoneOptional_110")} name="mobile" value={mobile || ''} onBlur={onBlur} onChange={onChange} error={err.mobile} />
          </div>
        </div>
        <div className="mt-2 row mx-0">
          <div className="col-block mr-2 ml-auto" >
            <button type="submit" className="btn manage-button manage-red-button " disabled={disabled}>{tr("common:save")}</button>
          </div>
          <div className="col-block" >
            <button type="button" className="btn manage-button manage-teal-button" disabled={disabled} onClick={onCancel}>{tr("common:back")}</button>
          </div>
        </div>
      </form>

    </div>
  );
};

StudentForm.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  clientUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ pathname: PropTypes.string, search: PropTypes.string })]),
  additionalInfo: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  client: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
};

StudentForm.defaultProps = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  additionalInfo: "",
  client: {},
  clientUrl: null,
};

export default StudentForm;
